import { ChangeDetectorRef, Component, Input, OnInit, EventEmitter, Output } from "@angular/core";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { ActivatedRoute } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { HomeService } from "../home.services";
import { PatentInfoService } from "./patent-info.service";
import * as FileSaver from "file-saver";
import { environment } from "src/environments/environment.prod";
import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic';


@Component({
  selector: "app-patent-info",
  templateUrl: "./patent-info.component.html",
  styleUrls: ["./patent-info.component.scss"],
})
export class PatentInfoComponent implements OnInit {
  @Input() MolData: any;
  @Input() ActiveIngred: any;
  @Input() saveOldData: any;
  @Input() BrandName: any;
  @Input() NDAnumber: any;
  @Output() patentHeaderUpdated = new EventEmitter<string>();
  Molecule: boolean;
  secondSectionData: any;
  links = 'window.open("http://43.205.223.1:8000';
  DragData: any = {};
  typeArray = ["paraI", "paraII", "paraIII", "paraIV"];
  newArray = [];
  contentTableArray = [];
  popupcontents: any;
  contentPopups = "none";
  content_Details: [];
  content_value: "";
  sliceEnd = 5;
  contentKey = "";
  displaypopup = "none";
  data: [][];
  refEditData = {};
  submolecules: any[];
  subMolecule = false;
  selectedSubMolecule: any;
  searchValue = "";
  noData = false;
  showedit = false;
  tempData: any = {};
  changed_Cols: [];
  nullmessage: any = "";
  tablekeys: string[];
  tableData: any = [];
  tablevalues: any = [];
  colorcode: {};
  // #headerid/
  setWidth: any;
  objectKeys = Object.keys;
  objectValues = Object.values;
  linkURL: any;
  paramsValues: any;
  editedData: any;
  storedData: any;
  keysArray: Array<String> = [];
  keyIds: Array<String> = [];
  showCheckBox = false;
  options: any = [];
  thirdSectionData: any = {};
  fourthSectionData: any = {};
  ApiInformationData: any = {};
  FormulationData: any = {};
  CompetitiveData: any = {};
  ExecutiveData: any = {};
  uniqNumber: any;
  UserIp: any;
  email: string;
  ShowLmsMessage: any;
  public Editor = ClassicEditor;
  public editorData = '<p>Type your content here...</p>';
  displayHeaderSelectionDialog: boolean = false;
  selectedHeaders: string[] = [];
  fieldInformation: any;
  displayReviewDialog: boolean = false;
  selectedKey: string = '';
  selectedEmail: any;
  reviewComment: string = '';
  emailList: any[] = [];
  drugName: any;
  drugActiveIngredient: any;
  drugNdaNumber: any;
  drugDosageForm: any;
  submitted: boolean = false; // Track form submission
  verificationMessage: string = '';
  htmlLoadingRowIndex: number | null = null;
  pdfLoadingRowIndex: number | null = null;
  private expandedPatentFocusCells = new Set<string>();

  constructor(
    private patentInfoService: PatentInfoService,
    private ref: ChangeDetectorRef,
    public toastr: ToastrService,
    private route: ActivatedRoute,
    private homeservice: HomeService,
    private sanitized: DomSanitizer
  ) { }

  ngOnInit(): void {
    this.uniqNumber = this.route.snapshot.queryParams["uniqnumber"];
    this.UserIp = localStorage.getItem("ipaddress");
    this.email = localStorage.getItem("email");
    this.fetchEmails();
    this.paramsValues = this.route.snapshot.queryParams;
    if (
      this.paramsValues.active_ingredient &&
      this.paramsValues.brand_name &&
      this.paramsValues.ndaValue &&
      this.paramsValues.section
    ) {
      this.getEditedChanges(
        this.paramsValues.active_ingredient,
        this.paramsValues.brand_name,
        this.paramsValues.ndaValue,
        this.UserIp,
        this.uniqNumber,
        this.email
      );
      this.Molecule = true;
    } else {
      this.getpatentInfo();
    }
  }

  getpatentInfo() {
    let active_ingredient = this.ActiveIngred;
    let brand_name = this.BrandName;
    let ndaValue = this.NDAnumber;
    let sectionTwo = "patent_information_details";
    const base64Encode = (str: string): string => {
      return btoa(unescape(encodeURIComponent(str)))
        .replace(/\+/g, '-')
        .replace(/\//g, '_')
        .replace(/=+$/, '');
    };

    const encodedActiveIngredient = base64Encode(active_ingredient);
    const encodedBrandName = base64Encode(brand_name);
    // this.linkURL = `${environment.ip}/#/home?active_ingredient=${encodedActiveIngredient}&brand_name=${encodedBrandName}&ndaValue=${ndaValue}&section=${sectionOne}`;
    this.linkURL = `${environment.ip}/#/home?active_ingredient=${encodedActiveIngredient}&brand_name=${encodedBrandName}&ndaValue=${ndaValue}&section=${sectionTwo}`;
    // this.linkURL = `http://3.111.249.237/#/home?active_ingredient=${active_ingredient}&brand_name=${brand_name}&ndaValue=${ndaValue}&section=${sectionTwo}`;
    this.patentInfoService
      .getSecondSection(ndaValue, brand_name)
      .subscribe((sec: any) => {
        this.Molecule = true;
        this.ShowLmsMessage = sec?.['status_message']
        this.colorcode = sec.data["PATENT INFORMATION"]["colorindicator"];
        this.fieldInformation = sec.data["PATENT INFORMATION"]["field_information"];
        console.log("fieldInformation", this.fieldInformation)
        this.checkFieldVerificationStatus();

        setTimeout(() => {
          // Emit the updated header with verification status
          const updatedHeader = this.verificationMessage; // Updated message
          console.log("Emitting:", updatedHeader); // Debugging the emission
          this.patentHeaderUpdated.emit(updatedHeader);  // Emit updated header value to parent
        }, 1000);
        this.DragData = sec.data["PATENT INFORMATION"];
        var productno = this.DragData["Orange Book patents"];
        for (let i = 0; i < productno.length; i++) {
          delete productno[i]["Product No"];
        }
        this.tempData = sec.data["PATENT INFORMATION"];
      });
  }

  checkFieldVerificationStatus() {
    // Start with the default message
    let verificationMessage = 'PATENT INFORMATION';

    // Iterate over each section (key) in fieldInformation
    for (const section in this.fieldInformation) {
      if (this.fieldInformation.hasOwnProperty(section)) {
        // Check if any item in the current section has field_verified as false
        const unverifiedField = this.fieldInformation[section].some(item => item.field_verified === false || item.field_verified === "N/A");

        if (unverifiedField) {
          // Add HTML span for highlighting the pending verification part
          verificationMessage += " - Verification of field is pending";
          break; // Stop after the first match (you can continue checking all sections if needed by removing this line)
        }
      }
    }

    // Store the final message (HTML)
    this.verificationMessage = verificationMessage;

    // Optionally, log the verification message
    console.log(this.verificationMessage);
  }

  showArray(data, n2, n3, n4, n5, n6, n7) {
    this.contentPopups = "block";
    this.contentTableArray = data;
  }
  Selectparam(event) {
    let referdata: any = localStorage.getItem("molecules");
    let moleculedata: any = this.saveOldData//JSON.parse(referdata);
    let brand_name: any;
    brand_name = moleculedata["Brand Name/Proprietary Name"];
    let obj = {
      type: event.target.value,
      brand_name: moleculedata["Brand Name/Proprietary Name"],
    };
    this.homeservice.addPara(obj).subscribe((res) => { });
  }

  showLess(data, n2, n3, n4, n5, n6, n7) {
    this.contentPopups = "block";
    this.tablekeys = Object.keys(data[0]);
    this.tablevalues = data;
  }

  /**
   *
   * @param InputProperty  value entered
   * @param Objectvalue     object values of the keys in an object
   * @returns
   */
  getcolorcode(InputProperty: string, Objectvalue: any): any {
    if (Objectvalue[InputProperty] !== undefined) {
      return Objectvalue[InputProperty];
    } else {
      return "";
    }
  }

  // getTooltipContent(key: string): string {
  //   if (this.fieldInformation && this.fieldInformation[key]) {
  //     return this.fieldInformation[key]
  //       .map(
  //         (item: any) =>
  //           `Source: ${item.source} <br> LMS No: ${item.lms_unique_no} <br> Approved By: ${item.field_approved_by} <br> Last Update: ${item.last_update_date}`
  //       )
  //       .join("<br><br>"); // Double <br> for spacing between items
  //   }
  //   return "No information available";
  // }

  getTooltipContent(key: string): string {
    if (this.fieldInformation && this.fieldInformation[key]) {
      return this.fieldInformation[key]
        .map(
          (item: any) =>
            `Source: ${item.source} <br> 
             LMS No: ${item.lms_unique_no} <br> 
             Approved By: ${item.field_approved_by} <br> 
             Last Update: ${item.last_update_date} <br> 
             Last Verified By: ${item.last_verified_by || "N/A"} <br> 
             Last Reviewed By: ${item.Last_reviewed_by || "N/A"} <br> 
             Last Verified Date: ${item.last_verified_date || "N/A"} <br> 
             Last Reviewed Date: ${item.last_reviewed_date || "N/A"}`
        )
        .join("<br><br>"); // Double <br> for spacing between items
    }
    return "No information available";
  }

  openReviewDialog(key: string) {
    this.selectedKey = key;
    this.displayReviewDialog = true;
  }

  fetchEmails() {
    this.homeservice.getUserMailId(this.email).subscribe(
      (response: any) => {
        console.log("API Response:", response);

        if (response && response.data) {
          this.emailList = response.data.map(item => ({ label: item.email, value: item.email })); // Correct format for p-dropdown
        } else {
          this.emailList = [];
        }

        console.log("Formatted Emails for Dropdown:", this.emailList);
      },
      error => {
        console.error("Error fetching emails:", error);
      }
    );
  }



  isCommentValid(): boolean {
    return this.selectedEmail && this.reviewComment.length >= 15;
  }

  submitReview() {
    this.submitted = true;
    if (!this.selectedEmail || !this.reviewComment || this.reviewComment.length < 15) {
      this.toastr.error("Please enter at least 15 characters in the comment.", "Error");
      return;
    }

    const reviewData = {
      user_mail: this.email,
      reviewer_email: this.selectedEmail,       // Email of the reviewer
      comment: this.reviewComment,     // Review comment (at least 15 chars)
      field: this.selectedKey,         // Field that is being reviewed
      section: "PATENT INFORMATION",   // Hardcoded section name
      drugBrandName: this.BrandName,         // Brand Name from API response
      drugNdaNumber: this.NDAnumber,   // NDA Number from API response
      // drugDosageForm: this.drugDosageForm  // Dosage Form from API response
    };

    console.log('Submitting:', reviewData);

    this.homeservice.submitFieldReview(reviewData).subscribe(
      (response) => {
        console.log("Review submitted successfully:", response);
        this.toastr.success("Reviewed field successfully", "Success");
        this.reviewComment = '';
        this.selectedEmail = '';
        this.displayReviewDialog = false;
        this.fieldInformation[this.selectedKey][0].field_reviewed = true; // Disable Review button
        this.fieldInformation[this.selectedKey][0].field_verified = false;
      },
      (error) => {
        console.error("Error submitting review:", error);
        this.toastr.error("Failed to submit review. Try again.", "Error");
      }
    );
  }


  verifyField(fieldKey: string) {
    const fieldInfo = this.fieldInformation[fieldKey];

    if (!fieldInfo) {
      this.toastr.error('Field information not found!', 'Error');
      return;
    }

    if (fieldInfo.field_verified) {
      this.toastr.info('Already Verified!', 'Info');
      return;
    }

    const payload = {
      user_mail: this.email,
      field_key: fieldKey,
      nda_number: this.NDAnumber,             // NDA Number from API response
      brand_name: this.BrandName,             // Brand Name from API response
    };

    console.log("Payload for verification:", payload);

    this.homeservice.verifyFieldData(payload).subscribe(
      (response) => {
        // console.log("Review submitted successfully:", response);
        this.toastr.success("Field verified successfully", "Success");
        this.fieldInformation[fieldKey][0].field_verified = true;
        this.fieldInformation[fieldKey][0].field_reviewed = false;

        // this.getpatentInfo();
      },
      (error) => {
        console.error("Failed to verify field", error);
        this.toastr.error("Failed to verify field. Try again.", "Error");
      }
    );
  }

  /**
   * Method to handle search
   */

  getEditedValues() {
    let referdata: any = localStorage.getItem("molecules");
    let moleculedata: any = JSON.parse(referdata);
    let active_ingredient = moleculedata["Active Ingredient"];
    let brand_name = moleculedata["Brand Name/Proprietary Name"];
    let ndaNumber = moleculedata["NDA number"];
    this.getEditedChanges(
      active_ingredient,
      brand_name,
      ndaNumber,
      this.UserIp,
      this.uniqNumber,
      this.email
    );
  }

  getEditedChanges(
    active_ingredient: string,
    brand_name: string,
    ndaNumber: number,
    userIp: string,
    uniqnumber: number,
    email: string
  ) {
    this.patentInfoService
      .getEditedData(
        active_ingredient,
        brand_name,
        ndaNumber,
        userIp,
        uniqnumber,
        email
      )
      .subscribe((res: any) => {
        if (this.paramsValues.section === "patent_information_details") {
          this.DragData = res.previously_updated_db_data;
          this.storedData = res.data.edited_data_key_insert_to_db;
        }
      });
  }

  isChanged(key): any {
    this.keysArray = [];
    if (this.storedData) {
      Object.keys(this.storedData).map((keys) => {
        if (keys === key) {
          this.keysArray.push(keys);
        }
      });
      return this.keysArray;
    }
  }

  editbtn() {
    this.showedit = !this.showedit;
    if (this.showedit === true) {
      this.sliceEnd = 1000;
    } else {
      this.sliceEnd = 5;
    }
  }

  downloadFiles() {
    // let referdata: any = this.saveOldData//localStorage.getItem("molecules");
    let moleculedata: any = this.saveOldData//JSON.parse(referdata);
    this.homeservice
      .getdownloadfile({
        nda_number: moleculedata["NDA number"],
        brand_name: moleculedata["Brand Name/Proprietary Name"],
      })
      .subscribe((res) => {
        let resp = res["data"]["content"];
        let file = res["data"]["filename"];
        FileSaver.saveAs(
          `data:application/vnd.ms-excel;base64,${resp}`,
          `${file}`
        );
      });
  }

  // Hide and show checboxes
  downloadSelected() {
    this.showCheckBox = !this.showCheckBox;
  }
  // Selecting the checkbox
  selected_checbox(event: any, index: number) {
    if (!this.options.includes(event)) {
      this.options = [...this.options, event];
    } else {
      this.options = this.options.filter((item) => item !== event);
    }
  }
  // Download based on selected items
  downloadSelectedData() {
    let referdata: any = localStorage.getItem("molecules");
    let moleculedata: any = this.saveOldData//JSON.parse(referdata);
    let columns_data = this.options;
    this.homeservice
      .downloadSelected({
        nda_number: moleculedata["NDA number"],
        brand_name: moleculedata["Brand Name/Proprietary Name"],
        columns_data,
      })
      .subscribe((res) => {
        let resp = res["data"]["content"];
        let file = res["data"]["filename"];
        FileSaver.saveAs(
          `data:application/vnd.ms-excel;base64,${resp}`,
          `${file}`
        );
      });
  }

  closecontentpopup() {
    // if (event === 'cancel') {

    this.content_Details = [];
    this.tableData = [];
    this.tablekeys = [];
    this.content_value = "";
    this.contentKey = "";
    this.contentPopups = "none";
    this.contentTableArray = [];
    // }
  }

  addClickEvent(event, value, key) {
    if (
      key === "Dosage and Administration" ||
      key === "Recommended dose" ||
      key === "Indications and Usage"
    ) {
      this.contentPopups = "block";
      this.content_Details = value;
      this.contentKey = key;
      this.content_value = "";
    } else if (
      key === "Variability (% ISCV)" ||
      key === "PK Linearity" ||
      key === "Food effect" ||
      key === "Pharmacology"
    ) {
      this.contentPopups = "block";
      this.content_Details = [];
      this.contentKey = key;
      this.content_value = value;
    } else {
      this.contentPopups = "none";
      this.content_Details = [];
      this.contentKey = "";
      this.content_value = "";
    }
    // if(event.type === 'mouseleave'){
    //   this.contentPopups = 'none';
    //   this.content_Details = [];
    //   this.contentKey ='';
    //   this.content_value ='';
    // }
  }

  addItems(data, n2, n3, n4, n5, n6, n7) {
    let objdata: any = this.DragData;
    let obj = {};
    let arr = [];
    let keys = Object.keys(data[0]);
    for (let i = 0; i <= keys.length - 1; i++) {
      obj[keys[i]] = "";
    }
    objdata[n7].push(obj);
    this.DragData = { ...objdata };
    this.ref.markForCheck();
  }

  // addListItem(data, n4, n5, n6, n7) {
  //   let objdata: any = this.DragData;
  //   let arr = [];
  //   console.log("Arrayyyy", objdata[n7].push(arr));
  //   this.DragData = { ...objdata };
  // }


  // addTable(data: any, n4: any, n5: any, n6: any, n7: string) {
  //   let objdata: any = this.DragData;
  //   console.log("this.objdata before", n7);

  //   // Initialize the array for the field if not already
  //   if (Array.isArray(objdata[n7])) {
  //     objdata[n7] = [];
  //   } else if (typeof objdata[n7] === 'string') {
  //     objdata[n7] = [];
  //   } else {
  //     objdata[n7] = [];
  //   }

  //   // Handle "PTE applied (Max 5 years)" field with a dialog box
  //   if (n7 === 'PTE applied (Max 5 years)') {
  //     this.displayHeaderSelectionDialog = true;
  //   } else {
  //     const headers = this.setHeadersBasedOnField(n7);
  //     this.createNewRow(objdata, n7, headers);
  //   }
  // }

  // selectHeaders(option: string) {
  //   if (option === 'granted') {
  //     this.selectedHeaders = ["Product", "Patent No", "Expiration date", "Extension Granted", "Expiration Post PTE"];
  //   } else if (option === 'requested') {
  //     this.selectedHeaders = ["Product", "Patent No", "Expiration date", "Extension Requested", "Expiration Post PTE"];
  //   }

  //   this.displayHeaderSelectionDialog = false;

  //   // Proceed with creating the table row using the selected headers
  //   const objdata: any = this.DragData;
  //   this.createNewRow(objdata, 'PTE applied (Max 5 years)', this.selectedHeaders);
  // }

  // setHeadersBasedOnField(n7: string): string[] {
  //   let headers;
  //   switch (n7) {
  //     case 'Orange Book patents':
  //       headers = ["Strength", "Patent No", "Patent Expiration", "Drug Substance", "Drug Product",
  //         "Patent Use Code", "Delist Requested", "Submission Date"];
  //       break;
  //     case 'Exclusivity details':
  //       headers = ["Exclusivity Code", "Exclusivity Expiration", "Strength"];
  //       break;
  //     case 'IPR details (if any)':
  //       headers = ["Proceeding Filing Date", "Proceeding Number", "Respondent Patent Number",
  //         "respondentPartyName", "Proceeding Status Category", "Proceeding Type Category", "Decision Date"];
  //       break;
  //     case 'Anticipated Market Formation Date':
  //       headers = ["Brand Name & Strength", "Anticipated market Formation date"];
  //       break;
  //     case 'Newly added Patents':
  //       headers = ["Strength", "Patent No", "Submission Date", "Drug Substance", "Drug Product", "Patent Use Code",
  //         "Delist Requested", "Patent Expiration"];
  //       break;
  //     case 'Delisted patents':
  //       headers = ["Strength", "Patent No", "Mkt Status", "Submission Date", "Patent Expiration"];
  //       break;
  //     default:
  //       headers = ["Default Header 1", "Default Header 2"];
  //       break;
  //   }
  //   return headers;
  // }

  // createNewRow(objdata: any, n7: string, headers: string[]) {
  //   let newRow = {};
  //   headers.forEach(header => {
  //     newRow[header] = "Cell " + (Object.keys(newRow).length + 1);
  //   });
  //   objdata[n7].push(newRow);

  //   this.DragData = { ...objdata };
  //   console.log("this.DragData after", this.DragData);
  //   this.tempData = { ...objdata };
  // }

  addTable(data, n4, n5, n6, n7) {
    let objdata: any = this.DragData;
    console.log("this.objdata before", n7);

    if (Array.isArray(objdata[n7])) {
      objdata[n7] = [];
    } else if (typeof objdata[n7] === 'string') {
      objdata[n7] = [];
    } else {
      objdata[n7] = [];
    }

    // let newRow = { "Header 1": "Cell 1", "Header 2": "Cell 2" };

    let headers;
    switch (n7) {
      case 'Orange Book patents':
        headers = ["Strength", "Patent No", "Patent Expiration", "Drug Substance", "Drug Product",
          "Patent Use Code", "Delist Requested", "Submission Date", "Patent Type", "Patent Focus"];
        break;
      case 'Exclusivity details':
        headers = ["Exclusivity Code", "Exclusivity Expiration", "Strength"];
        break;
      case 'PTE applied (Max 5 years)':
        headers = ["Status", "Product", "Patent No", "Expiry Date", "Extension", "Expiration Post PTE"];
        break;
      case 'IPR details (if any)':
        headers = ["Proceeding Filing Date", "Proceeding Number", "Respondent Patent Number",
          "respondentPartyName", "Proceeding Status Category", "Proceeding Type Category", "Decision Date"];
        break;
      case 'Anticipated Market Formation Date':
        headers = ["Brand Name & Strength", "Anticipated market Formation date"];
        break;
      case 'Newly added Patents':
        headers = ["Strength", "Patent No", "Submission Date", "Drug Substance", "Drug Product", "Patent Use Code",
          "Delist Requested", "Patent Expiration"];
        break;
      case 'Delisted patents':
        headers = ["Strength", "Patent No", "Mkt Status", "Submission Date", "Patent Expiration"];
        break;
      case 'Additional patents':
        headers = ["Patent No", "Patent Expiration", "Patent Type", "Patent Focus"]
        break;
      default:
        headers = ["Default Header 1", "Default Header 2"];
        break;
    }

    // Create a new row based on the defined headers
    let newRow = {};
    headers.forEach(header => {
      newRow[header] = "Cell " + (Object.keys(newRow).length + 1);
    });
    objdata[n7].push(newRow);

    this.DragData = { ...objdata };
    console.log("this.DragData after", this.DragData);
    this.tempData = { ...objdata };
  }

  deleteTable(key: string) {
    let objdata: any = this.DragData;

    if (objdata.hasOwnProperty(key)) {
      objdata[key] = "N/A";
    }

    this.DragData = { ...objdata };
    this.tempData = { ...objdata };

    console.log("Table deleted for key:", key);
  }

  addListItem(data, n4, n5, n6, n7) {
    let objdata: any = this.DragData;
    if (typeof objdata[n7] === 'string') {
      objdata[n7] = [objdata[n7]];
    }
    let arr = [];
    console.log("Arrayyyy", objdata[n7].push(arr));
    this.DragData = { ...objdata };
    this.tempData = { ...objdata };
  }

  deleteListItem(value: any, key: any, index: number) {
    console.log("deleteItemmm", value, index);
    let objdata: any = this.DragData;
    if (value.length > 1) {
      value.splice(index, 1);

      const keysToConvert = ['Additional patents', 'PDE applied 6 months*', 'IPR details (if any)',
        '505 B(2) Opportunity', 'Additional comments on patents', 'Delisted patents', 'Type of Filing',
        'Newly added Patents'];

      // Convert back to string if only one item left
      if (value.length === 1 && keysToConvert.includes(key)) {
        if (this.DragData[key]) {
          this.DragData[key] = value[0];
        }
      }

      this.DragData = { ...objdata };
    }
  }

  deleteRow(Obj: any, index: number) {
    let objdata: any = this.DragData;
    if (Obj.length > 1 && index > -1) {
      Obj.splice(index, 1);
      console.log("deleteRow", Obj, index);
      this.DragData = { ...objdata };
    }
  }

  //** We can edit the data based on object,array and array of objects */
  editdata(event, arr, keys, trows, rd, Obj, index, varikey, n9, n10) {
    if (Obj !== undefined) {
      if (this.tempData[keys] && Obj.value) {
        this.tempData[keys].map((res, j) => {
          Obj.value.map((resp, j1) => {
            if (j === index && j === j1) {
              let objkey = Object.keys(Obj.value[0]);
              let uniquekey = objkey[n10];
              resp[uniquekey] = event.target.value;
            }
          });
        });
      }
    }
    if (Obj === "lItems") {
      if (Array.isArray(this.tempData[keys])) {
        this.tempData[keys].map((respp, k) => {
          if (arr) {
            arr.map((resps, p) => {
              if (p === rd) {
                if (resps === trows) {
                  arr[rd] = event.target.value;
                }
              }
            });
          } else {
          }
        });
      }
    } else if (Obj === undefined) {
      this.tempData[keys] = event.target ? event.target.value : event;
      // this.tempData[keys] = event.target.value;
    }
  }

  saveEdit() {
    this.sliceEnd = 5;
    this.showedit = !this.showedit;
    let referdata: any = localStorage.getItem("molecules");
    let moleculedata: any = this.saveOldData//JSON.parse(referdata);
    let editedData: any = {};
    editedData["edited_data"] = this.tempData;
    editedData["nda_number"] = moleculedata["NDA number"];
    editedData["brand_name_proprietary_name"] =
      moleculedata["Brand Name/Proprietary Name"];
    editedData["active_ingredient"] = moleculedata["Active Ingredient"];
    editedData["link"] = this.linkURL;
    editedData["email"] = this.email;
    this.patentInfoService
      .SendEmail(
        editedData["active_ingredient"],
        editedData["brand_name_proprietary_name"],
        editedData["nda_number"],
        editedData["email"],
        editedData
      )
      .subscribe((res: any) => {
        if (res && res.error && res.error === "Pending in LMS. Please take actions first; then editing will be allowed.") {
          this.toastr.error(res.error, "Error", {
            timeOut: 10000,   // Toast duration in milliseconds
            positionClass: 'toast-top-right',  // Position the toast in the top-right corner
            closeButton: true
          });
        }
      });
  }

  handelAction(key, flag, i) {
    let updatedValue = {
      nda_number: this.paramsValues.ndaValue,
      field: key,
      flag,
      brand_name: this.paramsValues.brand_name,
      active_ingredient: this.paramsValues.active_ingredient,
      userip: localStorage.getItem("ipaddress"),
      uniqnumber: this.uniqNumber,
      email: localStorage.getItem("email"),
    };
    this.patentInfoService
      .updateMoleculeData(updatedValue)
      .subscribe((res: any) => {
        if (flag === "accept") {
          this.keyIds.push(key.key);
          document.getElementById(key.key).style.display = "none";
          this.toastr.success("Data updated sucessfully", "");
        } else {
          this.DragData = res.old_data_with_updated_set;
          this.keyIds.push(key.key);
          setTimeout(() => {
            this.keyIds.forEach((id: String) => {
              document.getElementById(`${id}`).style.display = "none";
            });
          }, 0);
          this.toastr.error("Data rejected sucessfully", "");
        }
      });
  }

  sanitizeHtml(html: string): SafeHtml {
    return this.sanitized.bypassSecurityTrustHtml(html);
  }

  openPdf(value) {
    let url: any = window.open(`https://oneclickfolio.com/pm_backend/${value}`);
    return this.sanitized.bypassSecurityTrustHtml(url);
  }

  private extractPatentNumber(raw: string | null | undefined): string | null {
    if (!raw) {
      return null;
    }

    const str = raw.toString().trim();

    // 1️⃣ First, handle RE-style patents (RE at the start)
    const reMatch = str.match(/^(RE)\s*[-\s]*?(\d+)/i);
    if (reMatch) {
      const prefix = reMatch[1].toUpperCase(); // "RE"
      const digits = reMatch[2];               // "40321"
      return `${prefix}${digits}`;             // "RE40321"
    }

    // 2️⃣ Fallback: just take the first continuous digit block (drop trailing letters)
    const genericMatch = str.match(/(\d+)/);
    if (genericMatch) {
      return genericMatch[1];                  // e.g. "8163904" from "8163904A"
    }

    return null;
  }


  private getUsptoPatentUrlFromBackend(patNo: string, isPdf: boolean): Promise<string | null> {
    return new Promise((resolve) => {
      this.patentInfoService.getUsptoPatentUrl(patNo, isPdf).subscribe(
        (res: any) => {
          const url = res && res.success && res.url ? res.url : null;
          if (!url) {
            console.error('USPTO URL missing in backend response:', res);
            this.toastr.error('USPTO URL not found for this patent.', 'Error');
            resolve(null);
            return;
          }
          resolve(url);
        },
        (err) => {
          console.error('Error fetching USPTO URL from backend:', err);
          this.toastr.error('Failed to resolve USPTO URL from server.', 'Error');
          resolve(null);
        }
      );
    });
  }

  public async openOrangeBookHtml(rowIndex: number): Promise<void> {
    const rows = this.DragData?.['Orange Book patents'];
    if (!rows || !Array.isArray(rows)) {
      this.toastr.error('Orange Book patent data not available.', 'Error');
      return;
    }

    const row = rows[rowIndex];
    if (!row || !row['Patent No']) {
      this.toastr.error('Patent No not found for the selected row.', 'Error');
      return;
    }

    const patNo = this.extractPatentNumber(row['Patent No']);
    if (!patNo) {
      this.toastr.error('Invalid patent number for HTML.', 'Error');
      return;
    }

    // 🔄 Start loader for this row (HTML)
    this.htmlLoadingRowIndex = rowIndex;

    try {
      const url = await this.getUsptoPatentUrlFromBackend(patNo, false);
      if (url) {
        window.open(url, '_blank');
      }
    } catch (err) {
      console.error('Error while opening USPTO HTML:', err);
      this.toastr.error('Error while opening USPTO HTML.', 'Error');
    } finally {
      // ✅ Stop loader
      this.htmlLoadingRowIndex = null;
    }
  }

  public async openOrangeBookPdf(rowIndex: number): Promise<void> {
    const rows = this.DragData?.['Orange Book patents'];
    if (!rows || !Array.isArray(rows)) {
      this.toastr.error('Orange Book patent data not available.', 'Error');
      return;
    }

    const row = rows[rowIndex];
    if (!row || !row['Patent No']) {
      this.toastr.error('Patent No not found for the selected row.', 'Error');
      return;
    }

    const patNo = this.extractPatentNumber(row['Patent No']);
    if (!patNo) {
      this.toastr.error('Invalid patent number for PDF.', 'Error');
      return;
    }

    // 🔄 Start loader for this row (PDF)
    this.pdfLoadingRowIndex = rowIndex;

    try {
      const url = await this.getUsptoPatentUrlFromBackend(patNo, true);
      if (url) {
        window.open(url, '_blank');
      }
    } catch (err) {
      console.error('Error while opening USPTO PDF:', err);
      this.toastr.error('Error while opening USPTO PDF.', 'Error');
    } finally {
      // ✅ Stop loader
      this.pdfLoadingRowIndex = null;
    }
  }
  private cellKey(sectionKey: string, rowIndex: number, colIndex: number): string {
    return `${sectionKey}::${rowIndex}::${colIndex}`;
  }

  isPatentFocusExpanded(sectionKey: string, rowIndex: number, colIndex: number): boolean {
    return this.expandedPatentFocusCells.has(this.cellKey(sectionKey, rowIndex, colIndex));
  }

  togglePatentFocus(sectionKey: string, rowIndex: number, colIndex: number): void {
    const key = this.cellKey(sectionKey, rowIndex, colIndex);
    if (this.expandedPatentFocusCells.has(key)) this.expandedPatentFocusCells.delete(key);
    else this.expandedPatentFocusCells.add(key);
  }
  isPatentFocusColumn(header: any): boolean {
    return (header ?? '')
      .toString()
      .toLowerCase()
      .replace(/\s+/g, ' ')
      .trim() === 'patent focus';
  }

  asText(val: any): string {
    return val == null ? '' : val.toString();
  }


}
